// src/components/shared/SectionGrid.js
// 2-column responsive field grid for the content of one AddFormLayout
// section. Replaces the old `<TextField margin="dense"/><br/>` stacking
// pattern. Wrap a field that needs the full row (multiline text areas,
// long paths) in <SectionGrid.FullWidth>.
import React from "react";
import Box from "@mui/material/Box";

const SectionGrid = ({ children }) => (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: 2,
      rowGap: 2.5,
    }}
  >
    {children}
  </Box>
);

SectionGrid.FullWidth = ({ children }) => (
  <Box sx={{ gridColumn: "1 / -1" }}>{children}</Box>
);

export default SectionGrid;
